/** True when slot participates in layout (not display:none / detached). */
export function isSlotLayoutVisible(container: HTMLElement): boolean {
  if (!container.isConnected) return false;
  const style = window.getComputedStyle(container);
  if (style.display === "none" || style.visibility === "hidden") return false;
  return container.getClientRects().length > 0;
}

/** Deepest Braze creative node inside a slot (iframe, img, or first child). */
export function getBannerContentEl(
  container: HTMLElement
): HTMLElement | null {
  const iframe = container.querySelector("iframe");
  if (iframe instanceof HTMLElement) return iframe;
  const img = container.querySelector("img");
  if (img instanceof HTMLElement) return img;
  const firstChild = container.firstElementChild;
  return firstChild instanceof HTMLElement ? firstChild : null;
}

/** Measure rendered banner height; falls back to container when creative is not ready. */
export function measureBannerSlotHeight(container: HTMLElement): number {
  const content = getBannerContentEl(container);
  if (content) {
    const contentHeight = Math.round(
      content.getBoundingClientRect().height || content.offsetHeight || 0
    );
    if (contentHeight > 0) return contentHeight;
  }

  return Math.round(
    container.getBoundingClientRect().height || container.offsetHeight || 0
  );
}

export type ApplySlotHeightOptions = {
  /** Smooth height change for inline slots (not used for global nav/footer). */
  animate?: boolean;
};

export function applySlotElementHeight(
  container: HTMLElement | null,
  px: number,
  options: ApplySlotHeightOptions = {}
): void {
  if (!container) return;

  if (px > 0) {
    if (options.animate) {
      container.dataset.brazeSlotAnimated = "true";
    }
    container.style.height = `${px}px`;
    container.style.minHeight = "";
  } else {
    container.style.height = "";
    container.style.minHeight = "";
    delete container.dataset.brazeSlotAnimated;
  }
}

export function clearSlotElementHeight(container: HTMLElement | null): void {
  applySlotElementHeight(container, 0);
}
